import type { LangDefinition, TranslocoConfig } from '@jsverse/transloco';
import { getBrowserLang } from '@jsverse/transloco';

import { createLogger } from '../logging';

const log = createLogger('ComputeDefaultLanguage');

const getFirstFallbackLang = (fallbackLang: string | Array<string> | undefined): string => {
  if (!fallbackLang) {
    return 'en';
  }

  if (Array.isArray(fallbackLang)) {
    return fallbackLang[0];
  }

  return fallbackLang;
};

export const computeDefaultLanguage: (translocoConfig: Partial<TranslocoConfig>) => string = (translocoConfig: Partial<TranslocoConfig>) => {
  const fallbackLang: string = getFirstFallbackLang(translocoConfig.fallbackLang);
  const browserLang: string | undefined = getBrowserLang();

  if (!browserLang) {
    return fallbackLang;
  }

  if (!translocoConfig.availableLangs) {
    throw new Error('Transloco is not configured properly because availableLangs is missing!');
  }

  const availableLangsIsStringBased = typeof translocoConfig.availableLangs[0] === 'string';
  const availableLangIds: Array<string> = availableLangsIsStringBased
    ? (translocoConfig.availableLangs as Array<string>)
    : (translocoConfig.availableLangs as Array<LangDefinition>).map(l => l.id);
  const browserLangIsAvailable = availableLangIds.includes(browserLang);

  if (!browserLangIsAvailable) {
    log.warn('Browser language is not available in the application, using the fallback language', { browserLang, fallbackLang });
    return fallbackLang;
  }

  return browserLang;
};
